import { Button, Card, Label, TableItem } from "components/atoms";
import ListWrapper from "components/molecules/list-wrapper/ListWrapper";
import { Table } from "components/organisms";
import { useScroll } from "components/templates/application/ApplicationTemplate";
import { useInfiniteTable } from "hooks/useInfiniteTable";
import { useCustomParamId, useParamId } from "hooks/useParamId";
import { t } from "i18next";
import {
  PiEye,
  PiNavigationArrow,
  PiThumbsDown,
  PiThumbsUp,
} from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useGetContractVideos } from "services/contract/products";

const ContractVideosTab = () => {
  const contractId = useParamId();

  const videos = useGetContractVideos(contractId);

  const scroll = useScroll({ fetchNextPage: videos.fetchNextPage });

  const navigate = useNavigate();

  return (
    <ListWrapper
      items={videos.data?.pages.flat()}
      isLoading={videos.isLoading}
      isFetchingNextPage={videos.isFetchingNextPage}
      item={(video) => (
        <Card
          key={video.id}
          header={video.videoTitle}
          description={video.isrc}
          onClick={() => navigate(`/video/${video.id}/data`)}
        />
      )}
    />
  );
};

export default ContractVideosTab;
